module.exports = __webpack_public_path__ + "static/media/communityLanding.a3b424c7.png";